import * as store from '@attain-apps/fe/web/main/lib/store'
import * as rxjs from 'rxjs'

import type * as clusters from '../../../../full/clusters'
import type { Plugin } from '../plugin'

/** Refreshes report filter options after a cluster is created, edited or deleted. */
export const reloadOptionsOnClusterChange = store.effects.create(
  (feature: Plugin['feature'], clustersEc: clusters.Collection) =>
    clustersEc.plugins.editingPlugin.feature.actions.submit.success
      .observe()
      .pipe(
        rxjs.map(action => feature.actions.loadOptions.from(action).create()),
      ),
)
